import { Container, Text } from "@mantine/core";
import { CmsPage } from "components/editor/CmsPage";
import RichTextEditor, {
  RichTextEditorRef,
} from "components/elements/editor/RichTextEditor";
import { useRef, useState } from "react";

const Tyopography = () => {
  const editorRef = useRef<RichTextEditorRef>(null);
  const [html, setHtml] = useState("<p>Hello world 👋</p>");
  const [editing, setEditing] = useState(true);

  return (
    <>
      <Container fluid size="md" py="xl" px="xs">
        <h1>CMS Editor Page</h1>
        <CmsPage pageTitle="about-us2" />

        <h1>Rich Text Editor</h1>
        <button onClick={() => setEditing((prev) => !prev)}>
          {editing ? "Preview" : "Edit"}
        </button>
        <button
          onClick={() => {
            const html = editorRef.current?.getHTML();
          }}
        >
          Export HTML
        </button>

        <RichTextEditor
          ref={editorRef}
          content={html}
          onChange={setHtml}
          readOnly={!editing}
          variant={editing ? "full" : "minimal"}
          placeholder="Write something amazing..."
        />
      </Container>

      <Container fluid size="md" py="xl" px="xs">
        <h1>Tyoography Styles</h1>
        <h1>H1 Title</h1>
        <h2>H2 Title</h2>
        <h3>H3 Title</h3>
        <h4>H4 Title</h4>
        <h5>H5 Title</h5>
        <h6>H6 Title</h6>

        <h1>Paragraphs</h1>
      </Container>
      <Container fluid size="md" px="md">
        <Text size="md">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur.
        </Text>
      </Container>
    </>
  );
};
export default Tyopography;
